export function areSetsEqual<T>(setA: Set<T>, setB: Set<T>): boolean {
  // Are the set sizes equal?
  if (setA.size !== setB.size) return false

  // Validate presence of items in a set
  for (const item of setA) {
    if (!setB.has(item)) return false
  }

  // All items in set are equal
  return true
}
